import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useForm, Controller } from 'react-hook-form';
import QuButton from '@quiqupltd/qu-react-sdk/lib/components/qu-button';
import QuTextArea from '@quiqupltd/qu-react-sdk/lib/components/qu-textarea';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';
import PropTypes from 'prop-types';
import { Rating } from './rating/rating';

const RateSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 15px;
  border: 1px solid ${props => props.theme.ghost300};

  &:nth-child(2) {
    margin: 10px 0;
  }

  /* rating component */
  & .react-stars {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  & [class^='react-stars-wrapper'] {
    width: 100%;
  }
`;

const Title = styled.p`
  color: ${props => props.theme.midnight500};
  text-transform: uppercase;
  margin: 0;

  ${media.up('phone')`
    font-size: ${pxToRem(12)};
  `};
`;

export const Disclaimer = styled.p`
  color: ${props => props.theme.grey};
  text-align: center;

  ${media.up('phone')`
    font-size: ${pxToRem(12)};
  `};
`;

const TellUsMore = styled.h2`
  font-size: ${pxToRem(24)};
  font-weight: 300;
  margin-bottom: 5px;
  color: ${props => props.theme.cornFlower500};
  text-align: center;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;

  .qu-button {
    padding: 15px 30px;
    height: auto;
  }

  .qu-button + .qu-button {
    margin-left: 0;
  }
`;

const ErrorMessage = styled.div`
  color: ${props => props.theme.red};
  font-size: ${pxToRem(12)};
  margin-top: 5px;
`;

const REQUIRED_ERROR = 'This field is required';
const ON_TIME = 'on-time';
const LATE = 'late';

export const RateDelivery = ({ onSubmit }) => {
  const {
    control,
    handleSubmit,
    setValue,
    register,
    watch,
    formState: { errors, isSubmitting },
  } = useForm();

  useEffect(() => {
    register('deliveryTime', { required: REQUIRED_ERROR });
  }, []);

  const deliveryTimeValue = watch('deliveryTime');

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <RateSection>
        <Title>How was the packaging condition?</Title>
        <Controller
          name="packageCondition"
          control={control}
          rules={{ required: REQUIRED_ERROR }}
          render={({ field }) => <Rating {...field} onChange={val => setValue('packageCondition', val)} />}
        />

        {errors.packageCondition && <ErrorMessage>{errors.packageCondition.message}</ErrorMessage>}
      </RateSection>
      <RateSection>
        <Title>How was your courier ?</Title>
        <Controller
          name="courier"
          control={control}
          rules={{ required: REQUIRED_ERROR }}
          render={({ field }) => <Rating {...field} onChange={val => setValue('courier', val)} />}
        />

        {errors.courier && <ErrorMessage>{errors.courier.message}</ErrorMessage>}
      </RateSection>
      <RateSection>
        <Title>How was your delivery ?</Title>

        <ButtonGroup>
          <QuButton
            onClick={() => setValue('deliveryTime', ON_TIME)}
            type={deliveryTimeValue === ON_TIME ? 'flat-primary' : 'flat'}
            buttonType="button"
          >
            On time
          </QuButton>
          <QuButton
            onClick={() => setValue('deliveryTime', LATE)}
            type={deliveryTimeValue === LATE ? 'flat-primary' : 'flat'}
            buttonType="button"
          >
            Late
          </QuButton>
        </ButtonGroup>

        {errors.deliveryTime && <ErrorMessage>{errors.deliveryTime.message}</ErrorMessage>}
      </RateSection>
      <div>
        <TellUsMore>Tell us more</TellUsMore>
        <Disclaimer>We are always looking to improve our service, let us know where we can improve. </Disclaimer>
        <Controller name="notes" control={control} render={({ field }) => <QuTextArea {...field} />} />
        <br />
        <QuButton type="primary" buttonType="submit" fluid loading={isSubmitting} disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </QuButton>
      </div>
    </form>
  );
};

RateDelivery.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/order-card/completed/body/rate-delivery/rate-delivery.js